const MinusIcon = () => (
  <svg
    width="12"
    height="2"
    viewBox="0 0 12 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.0013 1.83268C0.541066 1.83268 0.167969 1.45959 0.167969 0.999349V0.999349C0.167969 0.539112 0.541065 0.166016 1.0013 0.166016H11.0013C11.4615 0.166016 11.8346 0.539112 11.8346 0.999349V0.999349C11.8346 1.45959 11.4615 1.83268 11.0013 1.83268H1.0013Z"
      fill="black"
    />
  </svg>
);

export default MinusIcon;
